/*
 * piner store header — the parts the shared piner-header.js doesn't cover:
 *   1. Shop opens on hover on desktop, and swaps to a full-screen drawer
 *      on mobile (where the plain dropdown would be unusable).
 *   2. The Editorial / Catalog view switch, remembered per visitor.
 * Self-contained: no imports, load with a plain deferred <script>.
 */
(function pinerStoreHeader() {
  var MOBILE = 768;
  var VIEW_KEY = 'piner:view';
  var HOVER_CLOSE_DELAY = 220;

  function isMobile() {
    return window.matchMedia('(max-width: ' + MOBILE + 'px)').matches;
  }

  /* ---------------- view switch ---------------- */

  function currentView() {
    return document.documentElement.getAttribute('data-piner-view') === 'catalog'
      ? 'catalog'
      : 'editorial';
  }

  function markCurrentView() {
    var view = currentView();
    document.querySelectorAll('[data-view-set]').forEach(function (button) {
      button.classList.toggle('is-current', button.dataset.viewSet === view);
    });
  }

  function setView(view) {
    document.documentElement.setAttribute('data-piner-view', view);

    try {
      localStorage.setItem(VIEW_KEY, view);
    } catch (e) {
      /* private mode — the choice just won't outlive the page */
    }

    // Keep the URL shareable without adding a history entry per toggle.
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('view', view);
      window.history.replaceState({}, '', url);
    } catch (e) {}

    markCurrentView();
  }

  /* The Shop list drops over the View row below it. piner-header.js owns the
     open/close, so mirror its state onto the header for the CSS to react to.
     Its document listener is registered first, so by the time this runs the
     class list is already up to date. */
  function syncShopOpen() {
    var header = document.querySelector('.piner-header--store');
    var toggle = document.querySelector('[data-shop-toggle]');
    if (!header || !toggle) return;
    var list = toggle.parentElement.querySelector('.depth-list');
    header.classList.toggle('shop-open', !!list && list.classList.contains('is-active'));
  }

  /* ---------------- mobile drawer ---------------- */

  function drawer() {
    return document.querySelector('[data-shop-drawer]');
  }

  function openDrawer() {
    var el = drawer();
    if (!el) return;
    el.hidden = false;
    el.classList.add('is-open');
    document.body.classList.add('psh-drawer-open');
  }

  function closeDrawer() {
    var el = drawer();
    if (!el) return;
    el.classList.remove('is-open');
    el.hidden = true;
    document.body.classList.remove('psh-drawer-open');
  }

  /* Capture phase: on mobile the Shop button must open the drawer INSTEAD of
     the dropdown, so stop the event before piner-header.js sees it. */
  document.addEventListener(
    'click',
    function (event) {
      if (!isMobile()) return;
      if (!event.target.closest('[data-shop-toggle]')) return;
      event.stopPropagation();
      event.preventDefault();
      openDrawer();
    },
    true
  );

  document.addEventListener('click', function (event) {
    syncShopOpen();

    if (event.target.closest('[data-drawer-close]')) {
      closeDrawer();
      return;
    }

    var viewButton = event.target.closest('[data-view-set]');
    if (viewButton) {
      setView(viewButton.dataset.viewSet);
      // Close the dropdown the choice was made in.
      var list = viewButton.closest('.depth-list');
      if (list) {
        list.classList.remove('is-active');
        var trigger = list.parentElement.querySelector('[data-depth-toggle]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        window.dispatchEvent(new Event('resize')); // piner-header.js redraws its bands
      }
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    closeDrawer();
    syncShopOpen();
  });

  /* Clear button in the drawer search lights up only once something is typed */
  document.addEventListener('input', function (event) {
    var input = event.target.closest('[data-drawer-search]');
    if (!input) return;
    var el = drawer();
    if (el) el.classList.toggle('has-query', input.value.trim() !== '');
  });

  document.addEventListener('click', function (event) {
    if (!event.target.closest('[data-drawer-search-clear]')) return;
    var el = drawer();
    if (!el) return;
    var input = el.querySelector('[data-drawer-search]');
    if (input) {
      input.value = '';
      input.focus();
    }
    el.classList.remove('has-query');
  });

  /* ---------------- desktop hover for Shop ---------------- */

  function bindShopHover() {
    var toggle = document.querySelector('[data-shop-toggle]');
    if (!toggle) return;

    var menu = toggle.closest('.ph-menu');
    var list = menu && menu.querySelector('.depth-list');
    if (!menu || !list) return;

    // Leaving is tracked on the whole corner so the pointer can travel from the
    // trigger down into the open list without it closing underneath. The close
    // is also held briefly, so clipping a corner of the gap on the way over
    // doesn't shut the menu in your face.
    var corner = toggle.closest('.piner-header__corner') || menu;
    var closeTimer = null;

    function cancelClose() {
      if (closeTimer === null) return;
      clearTimeout(closeTimer);
      closeTimer = null;
    }

    function open() {
      if (isMobile()) return;
      cancelClose();
      if (!list.classList.contains('is-active')) toggle.click();
    }

    menu.addEventListener('mouseenter', open);
    corner.addEventListener('mouseenter', cancelClose);
    list.addEventListener('mouseenter', cancelClose);

    corner.addEventListener('mouseleave', function () {
      if (isMobile()) return;
      cancelClose();
      closeTimer = setTimeout(function () {
        closeTimer = null;
        if (list.classList.contains('is-active')) toggle.click();
      }, HOVER_CLOSE_DELAY);
    });
  }

  /* The footer carries its own Location / Language row, so the fixed corners
     step aside once it comes into view — otherwise both would show at the
     bottom of the page. (The footer used to cover them by z-index, but that
     also put it over the cart drawer.) */
  function syncFooter() {
    var footer = document.querySelector('.pfoot');
    if (!footer) return;
    var reached = footer.getBoundingClientRect().top < window.innerHeight;
    document.body.classList.toggle('store-foot-reached', reached);
  }

  function init() {
    markCurrentView();
    bindShopHover();

    syncFooter();
    window.addEventListener('scroll', syncFooter, { passive: true });
    window.addEventListener('resize', syncFooter);
    // Coming back to a wide viewport should never leave the drawer stuck open.
    window.addEventListener('resize', function () {
      if (!isMobile()) closeDrawer();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
